"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetaInformationImportationModal = exports.MetaImportationModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Context_1 = require("../../elements/popup/Modal/Context");
const options_1 = require("../../elements/popup/options");
const MetaImportationModal_1 = __importDefault(require("./MetaImportationModal"));
var MetaImportationModal_2 = require("./MetaImportationModal");
Object.defineProperty(exports, "MetaImportationModal", { enumerable: true, get: function () { return __importDefault(MetaImportationModal_2).default; } });
function useMetaInformationImportationModal() {
    const modal = (0, Context_1.useModal)();
    return (0, react_1.useCallback)((file) => {
        modal.show((0, jsx_runtime_1.jsx)(MetaImportationModal_1.default, { file: file, onClose: () => modal.close() }), {
            position: options_1.positions.MIDDLE,
            enableResizing: true,
            width: 900,
            height: 600,
        });
    }, [modal]);
}
exports.useMetaInformationImportationModal = useMetaInformationImportationModal;
